import { api } from '../../../utils/fetchApi';

export const handbookHasChangesLoader = () => {
  return api({
    method: 'GET',
    url: '/api/handbook/has_pending_changes',
  });
};
